import { render, staticRenderFns } from "./OrganizerGroupedReportDashboard.vue?vue&type=template&id=516c682c&"
import script from "./OrganizerGroupedReportDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganizerGroupedReportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports